import { BaseAction } from './BaseAction';
import Locale from '../../utils/Locale';

export class Disconnect extends BaseAction {
    public static getTitle:Function = () => Locale.gettext('Disconnect');
    public static getDescription:Function = () => Locale.gettext('The Attendant disconnects from the cloud');
    public static supportedRoutes:string[] = [ "push", "email" ];
}